<template>
    <main id="yagish_about">
        <section class="hero_block">
            <h2 class="h2_other renew2_wrapper">유용한 정보</h2>
        </section>

        <section id="article" class="renew2_wrapper article">
            <div class="article__hero">
                <h1>이력서 학력 기재법 완벽 정리｜작성 순서, 주의사항, 예시까지</h1>
                <img src="/kr/resume/static/img/article/article_guide_mv02.jpg" alt="이력서 학력 기재법 완벽 정리｜작성 순서, 주의사항, 예시까지"
                    class="mvimg">
                <p>이력서 작성 시 학력 항목은 단순한 정보 기재를 넘어, 지원자의 성장 배경과 신뢰도를 보여주는 중요한 요소입니다. 본 글에서는 학력을 올바르게 작성하는 법, 자주 하는 실수, 상황별
                    예시까지 자세히 알려드립니다.</p>
            </div>

            <div class="article__contents">
                <h2>1. 이력서에서 학력이 중요한 이유</h2>
                <!--<p></p>-->

                <h3>왜 학력 정보가 평가에 영향을 미치는가?</h3>
                <p>이력서에서 학력은 지원자의 기초 역량과 전공 분야, 문제 해결 능력 등을 간접적으로 보여주는 중요한 정보입니다. 특히 신입 지원자의 경우 직무 경험이 부족하므로 학력 정보가 더 큰
                    비중을 차지하며, 기본적인 성실성과 목표 의식을 평가하는 기준이 되기도 합니다.</p>

                <h3>인사 담당자가 학력을 통해 보는 것들</h3>
                <p>기업의 인사 담당자는 학력을 통해 전공과 직무 연관성을 우선적으로 확인하며, 어떤 환경에서 학습했는지도 주목합니다. 졸업 시기, 학업 성취도, 학교 네임밸류 등을 종합적으로 고려해
                    지원자의 기본 태도나 성장 가능성을 예측하기도 합니다.</p>

                <h2>2. 이력서 학력 작성 전 기본 원칙</h2>
                <p>이력서에서 학력은 기본 중의 기본 항목이지만, 그만큼 실수도 자주 발생하는 부분입니다. 단순히 다녔던 학교를 나열하는 것이 아니라, 이력서를 읽는 사람의 시선과 판단 기준을 고려해
                    전략적으로 작성해야 합니다. 아래는 학력란을 작성할 때 반드시 알아두어야 할 세 가지 핵심 원칙입니다.</p>

                <h3>학력은 최신 순으로 작성하는 이유</h3>
                <p>
                    이력서에 학력을 기재할 때는 반드시 최신 학력부터 역순으로 작성하는 것이 원칙입니다. 이는 인사 담당자가 지원자의 최종 학력과 직무 적합성을 빠르게 파악할 수 있도록 돕기
                    위함입니다. 예를 들어, 대학교를 졸업한 지원자의 경우, 고등학교 이력을 먼저 작성하면 가독성이 떨어지고 혼란을 줄 수 있습니다.
                    <br>
                    또한 최신 학력을 상단에 배치함으로써, 해당 학위에서 배운 전공 지식이나 활동 내역을 강조할 수 있는 장점도 있습니다. 특히 전공이 직무와 연관이 깊을 경우, 이 순서가 더욱
                    중요해집니다.
                </p>

                <h3>졸업, 재학, 중퇴 등 올바른 표현법</h3>
                <p>이력서에서는 학력의 상태를 정확하게 명시해야 하며, 다음과 같은 표현을 사용합니다:</p>

                <p>
                    졸업: “○○대학교 졸업”
                    <br>
                    재학 중: “○○대학교 재학 중 (재학기간: 20XX.03~현재)”
                    <br>
                    중퇴: “○○대학교 중퇴 (재학기간: 20XX.03~20XX.08)”
                    <br>
                    휴학 중: “○○대학교 휴학 중 (휴학 사유는 작성하지 않아도 됨)”
                </p>

                <p>중퇴나 휴학이 부정적으로 보일까 걱정하는 분들도 있지만, 솔직하고 간결하게 표현하는 것이 신뢰를 얻는 데 도움이 됩니다. 단, 사유 설명은 면접에서 질문이 나올 수 있으니 미리
                    준비해두는 것이 좋습니다.</p>

                <h3>중학교 이하는 생략해도 될까?</h3>
                <p>
                    일반적으로 중학교 이하는 이력서에 기재하지 않아도 됩니다. 고등학교 이상의 학력이 기준이 되며, 대부분의 기업은 고등학교부터의 이력을 통해 학업과 경력의 흐름을 파악합니다.
                    <br>
                    다만, 특별한 사정이나 활동 이력이 있다면 예외적으로 기재할 수 있습니다. 예를 들어, 외국에서 중학교를 다닌 이력이 있어 해외 생활 경험을 강조하고 싶거나, 예체능 계열에서
                    특수한 수상 경력이 있는 경우에는 간단히 언급할 수도 있습니다. 하지만 일반적인 경우에는 중학교 이하는 생략하는 것이 깔끔하고 전문적인 인상을 줍니다.
                </p>

                <h2>3. 상황별 학력 작성 방법</h2>
                <p>지원자의 학력은 단순한 학위명이 아니라, 어떤 배경과 경험을 가지고 있는지를 보여주는 중요한 단서입니다. 특히 개인의 학력 상황에 따라 작성 방식이 달라질 수 있기 때문에, 본인의
                    이력에 맞는 정확하고 전략적인 작성이 필요합니다. 아래는 대표적인 상황별 학력 작성 방법입니다.</p>

                <h3>● 고졸자의 경우</h3>
                <p>고등학교 졸업 후 바로 취업을 준비하는 경우에는 고등학교 명, 전공 계열(예: 인문계, 이공계 등), 졸업 여부, 재학 기간을 정확히 기재하는 것이 중요합니다.</p>

                <p>
                    예시:
                    <br>
                    ○○고등학교 졸업 (인문계) | 2018.03 ~ 2021.02
                </p>

                <p>만약 자격증이나 직업교육 과정을 이수했다면, 해당 내용을 학력 바로 아래에 따로 기재하여 전문성과 실무 역량을 강조하는 것이 좋습니다. 학력이 짧은 만큼, 자신이 쌓은 실질적인
                    경험을 어필하는 전략이 효과적입니다.</p>

                <h3>● 대졸자의 경우</h3>
                <p>대학교 졸업자는 학교명, 전공, 졸업 여부, 재학 기간을 기본으로 작성하고, 필요시 복수전공이나 부전공도 함께 기재할 수 있습니다.</p>

                <p>
                    예시:
                    <br>
                    ○○대학교 ○○학과 졸업 | 2017.03 ~ 2021.02
                </p>

                <p>
                    복수전공: 경영학과
                    <br>
                    대졸자는 학력 외에도 재학 중 활동(예: 프로젝트, 인턴, 학회 활동 등)을 간략히 요약하여 학력 아래에 넣으면 좋습니다. 이는 자신의 전공을 어떻게 실무와 연결시켰는지 보여줄 수
                    있는 좋은 기회입니다.
                </p>

                <h3>● 편입 또는 복수 전공이 있는 경우</h3>
                <p>편입한 경우에는 편입 전 학교와 편입 후 학교를 모두 기재해야 하며, 전공과 재학 기간을 각각 명확하게 구분합니다. 혼동을 피하기 위해 편입 사실을 괄호나 주석 형태로 덧붙이는 것이
                    좋습니다.</p>

                <p>
                    예시:
                    <br>
                    ○○대학교 ○○학과 졸업 (편입) | 2019.03 ~ 2022.02
                    <br>
                    △△대학교 ○○학과 중퇴 | 2017.03 ~ 2019.02
                </p>

                <p>복수전공 또는 부전공이 있을 경우, 전공을 병기하거나 따로 기재하여 전공의 깊이와 다양성을 강조할 수 있습니다.</p>

                <h3>● 해외 유학 또는 외국 학교 졸업자의 경우</h3>
                <p>해외 학교에서 졸업하거나 수학한 경우, 학교명은 영문으로 표기하고, 국가명과 재학 기간을 함께 적는 것이 좋습니다. 학위명도 현지 명칭과 함께 한글 병기를 하면 신뢰도를 높일 수
                    있습니다.</p>

                <p>
                    예시:
                    <br>
                    University of Toronto (캐나다) 심리학과 졸업 | 2016.09 ~ 2020.06
                    <br>
                    학위: Bachelor of Arts (문학사)
                </p>

                <p>또한, 해외에서 받은 학위가 한국 기준과 다를 수 있기 때문에, 채용 담당자가 이해할 수 있도록 간단한 설명을 덧붙이는 것도 도움이 됩니다. 특히 공공기관이나 국내 기업 지원 시에는
                    학력 인정 여부도 사전에 확인해두는 것이 좋습니다.</p>

                <h2>4. 잘못된 학력 작성 예시와 수정 방법</h2>
                <p>이력서에서 학력은 가장 기본적인 항목이지만, 실수가 자주 발생하는 부분이기도 합니다. 특히 정보 누락, 잘못된 날짜 표기, 불명확한 표현 등은 신뢰도를 크게 떨어뜨릴 수 있으므로
                    주의가 필요합니다. 이 섹션에서는 자주 보이는 실수와 올바른 수정 방법을 실제 예시를 통해 소개합니다.</p>

                <h3>생략하거나 부정확하게 쓰는 경우</h3>
                <p>학력을 기재할 때 중간 학력을 생략하거나 불분명한 표현을 사용하는 경우가 종종 있습니다. 예를 들어, 편입한 이력을 아예 쓰지 않거나, 중퇴 여부를 명확히 밝히지 않는 경우는 오해를
                    불러올 수 있습니다.</p>

                <p>
                    잘못된 예시:
                    <br>
                    ○○대학교 ○○학과 | 2018.03 ~ 2022.02
                    <br>
                    어떤 상태인지 알 수 없음 (졸업? 중퇴?)
                </p>

                <p>
                    수정된 예시:
                    <br>
                    ○○대학교 ○○학과 졸업 | 2018.03 ~ 2022.02
                    <br>
                    또는
                    <br>
                    ○○대학교 ○○학과 중퇴 | 2018.03 ~ 2020.08
                </p>

                <p>모호한 표현보다는 명확하게 졸업, 중퇴, 재학 중 여부를 밝히는 것이 신뢰를 줍니다.</p>

                <h3>날짜 오류, 표기 실수 바로잡기</h3>
                <p>입학 및 졸업 날짜가 실제 학사 일정과 맞지 않거나, 숫자가 틀린 경우는 매우 흔한 실수입니다. 인사 담당자는 학력 흐름을 통해 나이, 경력, 경로를 유추하기 때문에, 날짜 오류는
                    의심을 살 수 있습니다.</p>

                <p>
                    잘못된 예시:
                    <br>
                    ○○고등학교 졸업 | 2017.03 ~ 2020.03
                    <br>
                    실제 졸업일은 2020년 2월임
                </p>

                <p>
                    수정된 예시:
                    <br>
                    ○○고등학교 졸업 | 2017.03 ~ 2020.02
                </p>

                <p>또한, 학교 이름이나 학과명을 잘못 기재하거나 약어를 사용하는 것도 피하는 것이 좋습니다. 공식 명칭을 그대로 사용하는 것이 원칙입니다.</p>

                <h3>실제 수정 예시로 이해하기</h3>
                <p>아래는 잘못 작성된 학력 항목과 수정된 버전의 예시입니다.</p>

                <p>
                    잘못된 작성:
                    <br>
                    서울대 / 경영 / 2016 ~ 2020 졸업
                </p>

                <p>
                    수정된 작성:
                    <br>
                    서울대학교 경영학과 졸업 | 2016.03 ~ 2020.02
                </p>

                <p>
                    잘못된 작성:
                    <br>
                    ○○대학교 ○○학과 (졸업 여부 미기재)
                </p>

                <p>
                    수정된 작성:
                    <br>
                    ○○대학교 ○○학과 중퇴 | 2019.03 ~ 2021.08
                </p>

                <p>이처럼 간단한 수정을 통해 이력서의 신뢰도와 완성도를 높일 수 있습니다. 학력 항목이 깔끔하게 정리되어 있어야 다른 내용도 더 신뢰 있게 보이는 효과가 있습니다.</p>

                <h2>마무리 요약 및 체크리스트</h2>
                <p>
                    이력서에서 학력 항목은 단순한 배경 정보가 아니라, 지원자의 전문성, 성장 과정, 직무 연관성을 보여주는 핵심 요소입니다. 최신 순으로 정확하게 작성하고, 졸업·재학·중퇴 등의
                    상태를 명확히 표기하는 것이 기본입니다.
                    <br>
                    지원자의 상황에 따라 고졸, 대졸, 편입, 유학 등 다양한 방식으로 작성이 달라질 수 있으므로, 본인의 학력 흐름을 논리적이고 깔끔하게 정리하는 것이 중요합니다. 또한 자주
                    발생하는 실수—날짜 오류, 생략, 불명확한 표현—를 피하고, 기업이 이해하기 쉬운 형태로 작성해야 합니다.
                </p>
            </div>

            <div class="articlelist">
                <a href="/kr/resume/article" class="articlelist__link">기사 목록</a>
            </div>

        </section>
    </main>
</template>

<style lang="css" src="@/assets/css/renew_info.css"></style>
<style lang="scss" src="@/assets/scss/article/article.scss"></style>
<script>
export default {
    created: function () {
    }
}
</script>